import { handleActions } from 'redux-actions';
import { defaultPromotionalBannersWidgetState } from './defaults';
import { PromotionalBannersWidgetData } from './types';
import { initPromosPage } from '../../actions';
import {
  makeSpecificSaveableWidgetDataMergeFunction,
  saveableWidgetRequestMetaReducer,
  INITIAL_SAVE_REQUEST_META,
} from '../utils';
import {
  savePromotionalBanners,
  savePromotionalBannersFailure,
  savePromotionalBannersSuccess,
  setPromotionalBannersWidgetDeviationPageBanner,
  setPromotionalBannersWidgetProfileCoverBanner,
} from './actions';

const mergePromotionalBannersWidgetDataChange =
  makeSpecificSaveableWidgetDataMergeFunction(
    defaultPromotionalBannersWidgetState
  );

export default handleActions<PromotionalBannersWidgetData, any>(
  {
    [initPromosPage.toString()]: (
      state,
      action: ReturnType<typeof initPromosPage>
    ) => {
      const data: PromotionalBannersWidgetData['initialData'] = {
        deviationPageBanner: action.payload.data.banners.deviationPageBanner,
        profileCoverBanner: action.payload.data.banners.profileCoverBanner,
      };
      return {
        initialData: data,
        currentData: data,
        isDirty: false,
        saveRequest: INITIAL_SAVE_REQUEST_META,
      };
    },
    [setPromotionalBannersWidgetDeviationPageBanner.toString()]: (
      state,
      action: ReturnType<typeof setPromotionalBannersWidgetDeviationPageBanner>
    ) =>
      mergePromotionalBannersWidgetDataChange(state, {
        deviationPageBanner: action.payload.deviationPageBanner,
      }),
    [setPromotionalBannersWidgetProfileCoverBanner.toString()]: (
      state,
      action: ReturnType<typeof setPromotionalBannersWidgetProfileCoverBanner>
    ) =>
      mergePromotionalBannersWidgetDataChange(state, {
        profileCoverBanner: action.payload.profileCoverBanner,
      }),
    ...saveableWidgetRequestMetaReducer({
      initialAction: savePromotionalBanners,
      successAction: savePromotionalBannersSuccess,
      failureAction: savePromotionalBannersFailure,
    }),
  },
  defaultPromotionalBannersWidgetState
);
